import { FaWhatsapp } from "react-icons/fa";
import "../style/Whatsapp.css";

const Whatsapp = () => {
  return (
    <a
      href="https://api.whatsapp.com/send?phone=916363018056"
      target="_blank"
      rel="noreferrer"
      className="whatsapp-fab"
      aria-label="Chat with Bit Byte Foods on WhatsApp"
    >
      <FaWhatsapp size={28} />
    </a>
  );
};
export default Whatsapp;
